/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { getFinancialSummary, getFinancialSummaryTotal } from "../../requests/getHomeReports";
import { FinancialSummaryColumns } from "./FinancialSummaryColumns";
import { FinancialSummarySearch } from "./FinancialSummarySearch";
import { debounce } from "lodash";
import { customStylesFinancialSummary } from "./customStylesFinancialSummary";

export const FinancialSummary = () => {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');

  const fetchData = async (page, perPage, firstName, lastName) => {
    setLoading(true);
    try {
      const offset = (page - 1) * perPage;
      setData(await getFinancialSummary(perPage, offset, firstName, lastName));
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      await fetchData(page, perPage, firstName, lastName);
    })();
  }, [page, perPage]);

  useEffect(() => {
    (async () => {
      await debouncedFetch(page, perPage, firstName, lastName);
    })();
  }, [firstName, lastName]);

  const fetchDataDelayed = async (page, perPage, firstName, lastName) => {
    await fetchData(page, perPage, firstName, lastName);
    setTotalRows(await getFinancialSummaryTotal(firstName, lastName));
  };
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    (async () => {
      setTotalRows(await getFinancialSummaryTotal(firstName, lastName));
    })();
  }, []);

  const handlePerRowsChange = (newPerPage, newPage) => {
    setPerPage(newPerPage);
    setPage(newPage);
  };

  const debouncedFetch = React.useCallback(debounce(fetchDataDelayed, 1500), []);

  const handleFirstNameChange = (e) => {
    setFirstName(e.target.value);
  };

  const handleLastNameChange = (e) => {
    setLastName(e.target.value);
  };

  // Definir columnas
  const columns = FinancialSummaryColumns();
  const customStyles = customStylesFinancialSummary();

  return (
    <>
      <FinancialSummarySearch
        firstName={firstName}
        handleFirstNameChange={handleFirstNameChange}
        lastName={lastName}
        handleLastNameChange={handleLastNameChange}
      />
      <DataTable
        customStyles={customStyles}
        highlightOnHover
        columns={columns}
        data={data}
        progressPending={loading}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handlePerRowsChange}
        paginationPerPage={perPage}
        paginationRowsPerPageOptions={[10, 25, 50, 100, 250, 500, 1000]}
      />
    </>
  );
};
